"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var close_1 = require("./close");
var print_1 = require("./print");
var download_1 = require("./download");
var related_1 = require("./related");
var message_1 = require("./message");
var share_1 = require("./share");
exports.Icons = {
    close: close_1.Close,
    print: print_1.Print,
    download: download_1.Download,
    related: related_1.Related,
    message: message_1.Message,
    share: share_1.Share
};
//# sourceMappingURL=index.js.map